import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";

import "./styles.scss";

export const DateInput = ({
  className,
  disabled,
  error,
  name,
  onChange,
  placeholder,
  testId,
  value,
  ...props
}) => {
  const numberFormat = (val) => {
    let month = val.substring(0, 2);
    let date = val.substring(2, 4);
    let year = val.substring(4, 8);

    let mainVal;

    if (month.length === 1) {
      mainVal = `${month}M/DD/YYYY`;
    } else if (month.length === 2) {
      mainVal = `${month}/DD/YYYY`;
    }

    if (month.length && date.length === 1) {
      mainVal = `${month}/${date}D/YYYY`;
    } else if (month.length && date.length === 2) {
      mainVal = `${month}/${date}/YYYY`;
    }

    if (month.length && date.length && year.length === 1) {
      mainVal = `${month}/${date}/${year}YYY`;
    } else if (month.length && date.length && year.length === 2) {
      mainVal = `${month}/${date}/${year}YY`;
    } else if (month.length && date.length && year.length === 3) {
      mainVal = `${month}/${date}/${year}Y`;
    } else if (month.length && date.length && year.length === 4) {
      mainVal = `${month}/${date}/${year}`;
    }

    return mainVal;
  };

  return (
    <NumberFormat
      className={createClassNameString([
        "apti-CL",
        "apti-DateInput",
        "apti-Input",
        className,
        error && "error",
      ])}
      disabled={disabled}
      elementtype="input"
      format={numberFormat}
      name={name}
      onValueChange={onChange}
      placeholder={placeholder}
      type="text"
      value={value}
      {...getAutomationDataAttr(testId)}
      {...props}
    />
  );
};

DateInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  testId: PropTypes.string,
  value: PropTypes.string,
};

DateInput.defaultProps = {
  className: undefined,
  disabled: false,
  name: "",
  onChange: () => {},
  placeholder: undefined,
  testId: undefined,
  value: undefined,
};
